import React, { useEffect, useState } from 'react';
import { Table, Button, Spin, Modal, Form, Select, Tag, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CloseOutlined } from '@ant-design/icons';
import { RouteComponentProps, Link } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { getEcole } from '../ecole/ecole.reducer';
import { initializeNewScolarite, getScolarites, campagneReinscription } from './scolarite.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { StatutScolarite } from 'app/shared/model/scolarite.model';
import { getAnneeScolaire } from '../annee-scolaire/annee-scolaire.reducer';
import { StatusAnneeScolaire } from 'app/shared/model/anneeScolaire.model';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';

const Scolarite = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();
  const { Option } = Select;
  const scolarite = useAppSelector(state => state.scolarite.entity);
  const scolariteList = useAppSelector(state => state.scolarite.entities);
  const loading = useAppSelector(state => state.scolarite.loading);
  const [form] = Form.useForm();
  const [isProcessing, setProcessing] = useState(false);
  const currentYear = new Date().getFullYear();
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);

  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getScolarites({ ecoleId: props.match.params.ecoleid, anneeScolaireId: props.match.params.anneeScolaireId }));
    dispatch(getAnneeScolaire(props.match.params.anneeScolaireId));
  }, []);

  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const isComptable = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isDirecteur = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DIRECTEUR]));
  const [isCreatingScolarite, setCreatingScolarite] = useState(false);
  const hasAccess = isAdmin || isComptable || isDirecteur;
  const inactiveAnnee = useCheckIsAnneeInactive(props.match.params.anneeScolaireId);

  const saveScolarite = values => {
    const entity = {
      ...scolarite,
      ...values,
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
    };
    setCreatingScolarite(true);
    dispatch(initializeNewScolarite(entity)).then(() => {
      setCreatingScolarite(false);
    });
    form.resetFields();
  };

  const moisListe = [
    'INSCRIPTION',
    'JANVIER',
    'FEVRIER',
    'MARS',
    'AVRIL',
    'MAI',
    'JUIN',
    'JUILLET',
    'AOUT',
    'SEPTEMBRE',
    'OCTOBRE',
    'NOVEMBRE',
    'DECEMBRE',
  ];

  const handleInitiateScolarite = () => {
    const modal = Modal.info({
      title: (
        <div>
          <span>Nouvelle Scolarite</span>
          <Button type="text" onClick={() => modal.destroy()} style={{ float: 'right' }}>
            <CloseOutlined style={{ color: '#F28E19' }} />
          </Button>
        </div>
      ),
      content: (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vh' }}>
          <div style={{ width: '400px' }}>
            <Form
              form={form}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              layout="vertical"
              size="large"
              initialValues={{ scolarite: scolarite || null }}
              onFinish={saveScolarite}
            >
              <Form.Item
                rules={[
                  {
                    required: true,
                  },
                ]}
                label="Facture du mois"
                name={'mois'}
                required
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select placeholder="Choisissez un mois" style={{ width: '100%' }} optionFilterProp="children">
                  {moisListe
                    .filter(m => m !== 'INSCRIPTION')
                    .map((mois, index) => {
                      const isMonthYearDisabled = scolariteList.some(
                        scolariteA => scolariteA.mois === mois && +scolariteA.annee === currentYear
                      );

                      return (
                        <Option key={index} value={mois} disabled={isMonthYearDisabled}>
                          {mois}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Form>
          </div>
        </div>
      ),
      okText: 'Suivant',
      onOk() {
        try {
          setProcessing(true);
          form.submit();
        } catch (error) {
          console.error(error);
        } finally {
          setProcessing(false);
        }
      },
      width: '50%',
      okButtonProps: { disabled: isProcessing, style: { background: '#F28E19', color: 'white', border: '1px solid #F28E19' } },
    });
  };

  const renderOption = (id, record) => {
    return (
      <Space size="middle">
        <Button type="primary" style={{ height: 30, width: 45 }}>
          <Link to={`${match.url}/${record.id}/list`}>
            <FontAwesomeIcon icon="eye" />{' '}
          </Link>
        </Button>

        {hasAccess && (
          <Button
            type="primary"
            style={{
              height: 30,
              width: 45,
              backgroundColor: record.statutScolarite === StatutScolarite.EMIS ? '#ccc' : 'red',
              borderColor: record.statutScolarite === StatutScolarite.EMIS ? '#ccc' : 'red',
            }}
            disabled={record.statutScolarite === StatutScolarite.EMIS || inactiveAnnee}
          >
            <Link to={`${match.url}/${record.id}/delete`}>
              <FontAwesomeIcon icon={faTrash} />
            </Link>
          </Button>
        )}
      </Space>
    );
  };
  const { match } = props;
  const columns = [
    {
      title: 'Factures',
      dataIndex: 'moisAnnee',
      key: 'moisAnnee',
      render: text => <strong>{text}</strong>,
      align: 'center' as const,
    },
    {
      title: 'Date de Creation',
      dataIndex: 'dateDebut',
      key: 'dateDebut',
      align: 'center' as const,
    },
    {
      title: 'Statut',
      dataIndex: 'statutScolarite',
      key: 'statutScolarite',
      align: 'center' as const,
      render: statutScolarite =>
        statutScolarite === StatutScolarite.EN_ATTENTE ? (
          <Tag color="red">En attente</Tag>
        ) : statutScolarite === StatutScolarite.EMIS ? (
          <Tag color="blue">Envoyée</Tag>
        ) : (
          <Tag color="blue">{statutScolarite}</Tag>
        ),
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      align: 'center' as const,
      render: renderOption,
    },
  ];

  const data = scolariteList.map((scolariteL, i) => ({
    id: scolariteL.id,
    mois: scolariteL.mois,
    annee: scolariteL.annee,
    dateDebut: scolariteL.dateDebut,
    statutScolarite: scolariteL.statutScolarite,
    moisAnnee: `${scolariteL.mois}`,
  }));

  const sortedData = data.sort((a, b) => {
    return moisListe.indexOf(a.mois) - moisListe.indexOf(b.mois);
  });

  const hasInscriptionScolarite = scolariteList.some(s => s.mois === 'INSCRIPTION' && +s.annee === currentYear);

  const handleLaunchReinscriptionCampaign = () => {
    const modal = Modal.confirm({
      title: (
        <div>
          <span>Campagne de Réinscription</span>
          <Button type="text" onClick={() => modal.destroy()} style={{ float: 'right' }}>
            <CloseOutlined style={{ color: '#F28E19' }} />
          </Button>
        </div>
      ),
      content: (
        <div style={{ fontSize: '15px', lineHeight: '1.7', padding: '10px 0' }}>
          <p style={{ color: '#1677ff' }}>
            📌 Avant de lancer cette campagne, veuillez vous rendre dans le menu <strong>Upload</strong> et choisir l&apos;option{' '}
            <strong>Réinscription des élèves</strong>.
          </p>
          <p>
            Cette opération lancera une <strong>campagne unique de réinscription</strong> pour l&apos;année scolaire{' '}
            <strong>{anneeScolaire.nom}</strong>.
          </p>
          <p>
            Une inscription sera automatiquement créée pour chaque élève actuellement inscrit avec le statut{' '}
            <Tag color="purple">PROVISOIRE</Tag>.
          </p>
          <p>
            Des factures seront générées et envoyées aux parents. Dès paiement, l&apos;inscription deviendra <Tag color="blue">VALIDÉE</Tag>
            , puis <Tag color="green">INSCRIT</Tag>au démarrage de l&apos;année scolaire.
          </p>
          <p style={{ marginTop: '15px', color: '#cc0000' }}>
            ⚠️ Cette opération est irréversible et ne peut être lancée qu&apos;une seule fois pour cette année.
          </p>
          <p style={{ marginTop: '10px' }}>
            <strong>Confirmez-vous le lancement de la campagne ?</strong>
          </p>
        </div>
      ),
      okText: 'Lancer',
      cancelText: 'Annuler',
      okButtonProps: {
        style: {
          background: '#F28E19',
          color: 'white',
          border: '1px solid #F28E19',
        },
        disabled: isProcessing,
      },
      width: 550,
      centered: true,
      async onOk() {
        try {
          setProcessing(true);
          await dispatch(
            campagneReinscription({
              ecoleId: props.match.params.ecoleid,
              anneeScolaireId: props.match.params.anneeScolaireId,
            })
          );
        } finally {
          setProcessing(false);
        }
      },
    });
  };

  return (
    <div>
      <h2>Facture scolarité</h2>
      <div style={{ margin: '0 auto', textAlign: 'center' }}>
        <div style={{ textAlign: 'right' }}>
          {anneeScolaire.statutAnneeScolaire === StatusAnneeScolaire.INACTIVE && !hasInscriptionScolarite && (
            <Button
              onClick={handleLaunchReinscriptionCampaign}
              disabled={isCreatingScolarite || !inactiveAnnee}
              style={{
                background: '#7cec48',
                color: 'white',
                borderRadius: '8px',
                marginRight: '10px',
                border: '1px solid #7cec48',
              }}
            >
              {isCreatingScolarite ? (
                <Spin />
              ) : (
                <>
                  <FontAwesomeIcon icon="retweet" style={{ marginRight: '8px' }} />
                  Lancer la Campagne de Réinscription
                </>
              )}
            </Button>
          )}
          &nbsp;
          {anneeScolaire.statutAnneeScolaire !== StatusAnneeScolaire.CLOTUREE && (
            <Button
              onClick={handleInitiateScolarite}
              disabled={isCreatingScolarite || inactiveAnnee}
              style={{
                background: isCreatingScolarite || inactiveAnnee ? '#ccc' : '#F28E19',
                color: 'white',
                borderRadius: '8px',
                border: `1px solid ${isCreatingScolarite || inactiveAnnee ? '#ccc' : '#F28E19'}`,
              }}
            >
              {isCreatingScolarite ? (
                <Spin />
              ) : (
                <>
                  <FontAwesomeIcon icon="plus" style={{ marginRight: '8px' }} />
                  Nouvelle facture
                </>
              )}
            </Button>
          )}
        </div>
        &nbsp;
        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={columns} dataSource={sortedData} bordered pagination={false} />
          </Spin>
        </div>
        <div style={{ marginBottom: '50px' }}></div>
      </div>
    </div>
  );
};
export default Scolarite;
